module.exports = __webpack_public_path__ + "img/university-header-left-texture.533da975.svg";